import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Drop from 'hb-builder/components/common/Drop';
import { useBuilderConfigContext } from 'hb-builder/contexts/BuilderConfigContext';
import {
  BUILDER_DOCUMENT_CHILDREN_TYPE,
  BUILDER_DOCUMENT_TYPE,
} from 'hb-react/backoffice/types/builder/builderDocument';

const componentType = BUILDER_DOCUMENT_CHILDREN_TYPE.DROPPABLE_LAST_BLOCK;

const DroppableLastBlock = () => <div />; // never used

const RenderBuilder = () => {
  const { type: templateType } = useBuilderConfigContext();

  return (
    <Drop
      accept={['section', 'structure', 'single']}
      placeholderPositions={['top']}
    >
      {({ ref: dropRef }) => (
        <DropBox
          data-testid="droppable-last-block-box"
          height={templateType === BUILDER_DOCUMENT_TYPE.PAGE ? '200px' : 0}
          ref={dropRef}
        />
      )}
    </Drop>
  );
};

const Render = () => null;

DroppableLastBlock.componentName =
  BUILDER_DOCUMENT_CHILDREN_TYPE.DROPPABLE_LAST_BLOCK;
DroppableLastBlock.componentType = componentType;
DroppableLastBlock.componentCategory = 'simple';

DroppableLastBlock.canBeDoubleClicked = false;
DroppableLastBlock.canBeDragged = false;
DroppableLastBlock.canBeListed = false;
DroppableLastBlock.canBeSelected = false;

DroppableLastBlock.RenderBuilder = RenderBuilder;
DroppableLastBlock.Render = Render;

DroppableLastBlock.item = null;

export default DroppableLastBlock;

const DropBox = styled(Box).attrs(() => ({
  width: '100%',
}))``;
